<template>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name'), sort: 'Name' },
                { title: $t('Lastname'), sort: 'Lastname' },
                { title: $t('SocialSecurityNumber'), sort: 'SocialSecurityNumber' },
                { title: $t('CreationDate'), sort: 'CreationDate' },
              ]"
            >
              <template slot-scope="{ row }">
                <td>
                  {{ row.name }}
                </td>
                <td>
                  {{ row.family }}
                </td>
                <td style="direction: ltr">
                  {{ row.nationalCode }}
                </td>
                <td style="direction: ltr">
                  {{ row.createOn }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
  import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
  import DataGrid from "@/components/datagrid/DataGrid";
  export default {
    components: {
      DataGrid,
    },
    data() {
      return {
        itemList: [],
        parentType: 0,
        gridDataSource: {
          type: "app",
          service: "/Credits/api/PettyCashesQuery",
        },
        gridSearchData: {
          keyword: "",
        },
      };
    },
    methods: {

    },
  }
  </script>

<style scoped></style>
